<mat-card
    appearance="outlined"
    class="surface"
    [class.selected]="selected()"
    [class.hoverable]="hoverable()"
>
    <div class="row">
        <ng-content select="qpx-grid-item-leading" />
        <ng-content select="qpx-grid-item-content" />
        <ng-content select="qpx-grid-item-trailing" />
    </div>
    <ng-content select="qpx-grid-item-details" />
</mat-card>
